// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3e6Q3","rootSuccess":"CompleteLink_rootSuccess__2t59U","rootFailure":"CompleteLink_rootFailure__1COrI","isDisabled":"CompleteLink_isDisabled__2KOYv"};